/*
 * @Author: DQL
 * @Date: 2020-08-11 16:23:01
 * @LastEditors: DQL
 * @LastEditTime: 2020-08-13 15:27:38
 * @Description: 菜单权限维护
 */
import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

// 获取权限树
export const getPermissionTree = () => { return axios.get(`${commontCtx}/permission`); };

// 获取权限菜单树
export const getMenuPermission = (menuCode, elementCode) => { return axios.get(`${commontCtx}/menupermission/permission/${menuCode}/${elementCode}`); };

// 保存菜单权限关联信息
export const updateMenuPermission = (fd) => { return axios.post(`${commontCtx}/menupermission/menu/save`, fd); };

// 获取菜单树
export const getMenuTree = () => { return axios.get(`${commontCtx}/menu/v2/tree`); };
